import React from "react";
import { Route, Routes } from "react-router-dom";
// import { useSelector } from "react-redux";
import ListAppointmentConfig from "../Components/Appoinment Config/listAppoinmentConfig";

const AppointmentConfigRoutes = () => {
  // const { admin } = useSelector((state) => state.admin || {});
  // const accessCode = admin?.data?.access_code || [];

  // const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  //   const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  //   const hasPermission = canAdd || canEdit;
  return (
    <Routes>
      <Route path="/appointment_config" element={<ListAppointmentConfig />}></Route>
    </Routes>
  );
};

export default AppointmentConfigRoutes;
